import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../../../../firmwareAssignmentState/firmwareAssignmentContext';
import Firmware from './components/Firmware';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Firmwares.module.scss';

const Firmwares: React.FC = () => {
	const { setIDsSelectedRestaurants, searchStringForFirmwares, IDsSelectedRestaurants, firmwares } =
		useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);

	const filteredFirmwares = useMemo(() => {
		if (searchStringForFirmwares) {
			const updatedFirmwares = firmwares.map((el) => {
				const filteredFirmwaresByName = el.firmwares.filter((firmware) =>
					firmware.firmwareName?.toLowerCase().includes(searchStringForFirmwares.toLowerCase()),
				);
				return { ...el, firmwares: filteredFirmwaresByName };
			});
			return updatedFirmwares;
		}
		return firmwares;
	}, [searchStringForFirmwares, firmwares]);

	const changeCloseStatus = (restaurantID: string) => {
		const copyIDsSelectedRestaurants = { ...IDsSelectedRestaurants };
		copyIDsSelectedRestaurants[restaurantID] = !copyIDsSelectedRestaurants[restaurantID];
		setIDsSelectedRestaurants(copyIDsSelectedRestaurants, false);
	};

	const deleteRestaurant = (restaurantID: string) => {
		const copyIDsSelectedRestaurants = { ...IDsSelectedRestaurants };
		delete copyIDsSelectedRestaurants[restaurantID];
		setIDsSelectedRestaurants(copyIDsSelectedRestaurants, true);
	};

	return (
		<div data-test="Firmwares">
			{filteredFirmwares.map((el) => {
				const wrapperClasses = classNames(style.wrapper, {
					[style.collapsedWrapper]: !IDsSelectedRestaurants[el.restaurantId],
				});

				return (
					<div key={el.restaurantId + 'mainDisplayFirmwaresTab'}>
						<div className={wrapperClasses}>
							<div className={style.category}>
								<div className={style.name} onClick={() => changeCloseStatus(el.restaurantId)}>
									<Text
										translationKey={el.restaurantAddress}
										theme={!IDsSelectedRestaurants[el.restaurantId] ? 'secondary' : 'contrast'}
										withTooltip={true}
									/>
									<svg className={style.pointerIcon}>
										<use xlinkHref={`${breadcrumbs}#next`} />
									</svg>
								</div>
								<svg className={style.closeIcon} onClick={() => deleteRestaurant(el.restaurantId)}>
									<use xlinkHref={`${breadcrumbs}#close`} />
								</svg>
							</div>
							<div className={style.subcategory}>
								{el.firmwares.length ? (
									<Firmware data={el.firmwares} restaurantID={el.restaurantId} />
								) : (
									<Text
										translationNameSpace="listing"
										translationKey="noFirmwaresLabel"
										theme="errorDark"
										weight="bold"
										align="center"
									/>
								)}
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default Firmwares;
